import {alpha, Theme} from "@mui/material/styles";

/** The plain grey of the admin cards on the white page; their fields stay white. */
export const adminCardSurface = (theme: Theme) => ({
	bgcolor: theme.palette.mode === 'light' ? '#f4f5f7' : alpha('#fff', 0.04),
	'& .MuiOutlinedInput-root': {bgcolor: 'background.paper'},
})
